import * as React from 'react';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext';
}

export default AccordionContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Accordion/AccordionContext.js
// module id = 301
// module chunks = 0